import * as React from 'react';

import { ShareTable } from '../../../shared';
import { Paper, Typography, LinearProgress } from '@material-ui/core';

// tslint:disable-next-line:no-empty-interface
export interface IPublisherStoreShareProps {
    dataStoreArray: any[],
    dataMarketArray:any[],
    loading:any
}

// tslint:disable-next-line:no-empty-interface
export interface IPublisherStoreShareState {
}

const dataFilled = (data: any) => {
    return data && !!data.length
}

export class PublisherStoreShare extends React.Component<IPublisherStoreShareProps, IPublisherStoreShareState> {
    constructor(props: IPublisherStoreShareProps) {
        super(props);
    }

    public render() {
        return  (
            <Paper className="publisher-sale-block panel-block">
                <Typography variant="headline" className="panel-title" component="title">
                    Share por Loja
                </Typography>
                {
                    this.props.loading
                    ?
                    <LinearProgress />
                    :
                    (
                        dataFilled(this.props.dataStoreArray)
                        ?
                        (<ShareTable table_main={this.props.dataStoreArray} table_01={this.props.dataStoreArray} table_02={this.props.dataMarketArray} title={"Share por Loja"} showMax={5} />)
                        :
                        (<Typography variant="body2" className="comparative" component="p">
                            Não há informações de vendas
                        </Typography>)
                    )
                }
            </Paper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/publisher/sale/store-share/PublisherStoreShare.tsx